
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/madhya-pradesh/mptak-baithak",
      function () {
        return require("private-next-pages/madhya-pradesh/mptak-baithak/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/madhya-pradesh/mptak-baithak"])
      });
    }
  